import { render } from "./LogarView.vue?vue&type=template&id=59dae8e9&scoped=true"
import script from "./LogarView.vue?vue&type=script&lang=js"
export * from "./LogarView.vue?vue&type=script&lang=js"

import "./LogarView.vue?vue&type=style&index=0&id=59dae8e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59dae8e9"]])

export default __exports__